import React from 'react'
import { Link } from 'gatsby-link'
import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: ${calculateResponsiveSize(120)} ${calculateResponsiveSize(0)}
    ${calculateResponsiveSize(120)};
  background: transparent;

  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(60)}
      ${calculateMobileResponsiveSize(32)} ${calculateMobileResponsiveSize(60)};
  }
`
export const Next = styled((props) => <Link {...props} />)`
  font-family: 'Berthold Akzidenz Grotesk';

  font-size: ${calculateResponsiveSize(48)};
  font-weight: 500;
  line-height: ${calculateResponsiveSize(52.8)};
  letter-spacing: 0.03em;
  text-align: center;

  color: var(--blue);
  flex-direction: column;
  text-transform: uppercase;
  border-bottom: ${calculateResponsiveSize(1)} solid var(--blue);
  a,
  a:hover,
  a:active,
  a:visited {
    color: var(--blue);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(20)};
    line-height: ${calculateMobileResponsiveSize(26)};
    letter-spacing: 0.05em;
  }
`
